import { forwardRef, ForwardRefRenderFunction, HTMLProps, ReactNode } from 'react';
import styles from './checkboxFilterWrapper.module.scss';

interface CheckboxFilterWrapperProps extends HTMLProps<HTMLDivElement> {
    children: ReactNode;
}

const CheckboxFilterWrapper: ForwardRefRenderFunction<HTMLDivElement, CheckboxFilterWrapperProps> = (
    { children, ...props },
    ref
) => {
    return (
        <div className={styles.filterFormCell} {...props} ref={ref}>
            {children}
        </div>
    );
};

const CheckboxFilterWrapperWithRef = forwardRef(CheckboxFilterWrapper);

export default CheckboxFilterWrapperWithRef;
